import {
  Component,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from "@angular/forms";
import { AuthenticationService } from "../../_services/index";
import { UserService } from "../../_services/user.service";
import { ToastrService } from "ngx-toastr";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import { BsModalService } from "ngx-bootstrap/modal";
import { SurveyService } from "../../_services/survey.service";
import { NgxCarousel } from "ngx-carousel";

@Component({
  moduleId: module.id,
  selector: "app-login",
  templateUrl: "./interviewlogin.component.html",
  styleUrls: ["./interviewlogin.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class InterviewLoginComponent implements OnInit {
  model: any = {};
  loading = false;
  error = "";
  showLogin = true;
  form: FormGroup;
  forgotForm: FormGroup;
  counties: any = [];
  zipcodes: any = [];
  showForgotPassword = false;
  startPage = true;
  secondPage = false;
  modalRef: BsModalRef;
  carouselImgages: any = [];
  public carouselTileOneItems: Array<any> = [];
  public carouselTileOne: NgxCarousel;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private surveyService: SurveyService
  ) {}

  ngOnInit() {
    // reset login status
    //this.authenticationService.logout();

    // CHECK THE isLoggedIn STATE HERE
    if (this.authenticationService.isUserLoggedIn()) {
      setTimeout(() => {
        this.router.navigateByUrl("survey");
      }, 1);
    }

    this.carouselImgages = [
      {
        name: "Oklahoma Disability Law Center",
        path: "assets/img/odlc_.svg",
        link: "http://okdlc.org/",
      },
      {
        name: "Oklahoma Indian Legal Services",
        path: "assets/img/oils.svg",
        link: "http://oilsonline.org/www.oilsonline.org/Welcome_to_OILS.html",
      },
      {
        name: "Legal Aid Services of Oklahoma",
        path: "assets/img/laso.svg",
        link: "http://www.legalaidok.org/",
      },
      {
        name: "Legal Services Corporation logo",
        path: "assets/img/lsc.svg",
        link: "https://www.lsc.gov/",
      },
      {
        name: "Oklahoma Access to Justice Commission",
        path: "assets/img/okaj.svg",
        link: "https://sites.google.com/utulsa.edu/okaccesstojustice/home",
      },
      {
        name: "Pro Bono Net",
        path: "assets/img/probonet.svg",
        link: "https://www.probono.net/",
      },
      {
        name: "Legal shield",
        path: "assets/img/legal-shield.svg",
        link: "https://lp.legalshield.com/laso/",
      },
      /*{name: 'Oklahoma Attorney Resources', path: 'assets/img/oar.svg', link: 'http://www.oklahomaattorneyresources.org/'}*/
    ];

    this.carouselTileOne = {
      grid: { xs: 2, sm: 4, md: 6, lg: 7, all: 0 },
      speed: 600,
      interval: 2500,
      point: {
        visible: true,
        /*pointStyles: `
                    .ngxcarouselPoint {
                      list-style-type: none;
                      text-align: center;
                      padding: 12px;
                      margin: 0;
                      white-space: nowrap;
                      overflow: auto;
                      box-sizing: border-box;
                    }
                    .ngxcarouselPoint li {
                      display: inline-block;
                      border-radius: 50%;
                      background: #6b6b6b;
                      padding: 5px;
                      margin: 0 3px;
                      transition: .4s;
                    }
                    .ngxcarouselPoint li.active {
                        border: 2px solid rgba(0, 0, 0, 0.55);
                        transform: scale(1.2);
                        background: transparent;
                      }
                  `*/
      },
      load: 2,
      loop: true,
      //touch: true,
      easing: "ease",
      animation: "lazy",
    };

    this.form = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      username: [null, [Validators.required], this.isUsernameUnique.bind(this)],
      email: [
        null,
        [Validators.required, Validators.email],
        this.isEmailUnique.bind(this),
      ],
      password: [null, Validators.required],
      confirmpassword: [null, Validators.required],
      //county: [null, Validators.required],
      //zip: [null, Validators.required]
    });

    this.forgotForm = this.formBuilder.group({
      email: [
        null,
        [Validators.required, Validators.email],
        this.isRegisteredUser.bind(this),
      ],
    });

    //this.getCounties();

    //this.carouselTileOneLoad();
  }

  /*public carouselTileOneLoad() {
        const len = this.carouselTileOneItems.length;
        if (len <= 20) {
          for (let i = 0; i < this.imgags.length ; i++) {
            this.carouselTileOneItems.push(
              this.imgags[Math.floor(Math.random() * this.imgags.length)]
            );
          }
        }
    }*/

  toggleLogin(boolean) {
    this.model = {};
    this.form.reset();
    this.error = "";
    this.showLogin = boolean;
    this.showForgotPassword = false;
  }

  toggleForgotPassword(boolean) {
    this.model = {};
    this.form.reset();
    this.error = "";
    this.forgotForm.reset();
    this.showForgotPassword = boolean;
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  userLogin() {
    this.loading = true;
    localStorage.clear();
    this.authenticationService
      .userLogin(this.model.email, this.model.password)
      .subscribe((result) => {
        if (result === true) {
          //Get latest draft
          this.surveyService.latestDraft().subscribe((data) => {
            if (data.status === 200) {
              //success
              let draft = data.json();
              if (Object.keys(draft).length > 0) {
                localStorage.setItem(
                  "draftBranch",
                  JSON.stringify({
                    projectId: draft.project_id,
                    repeatCount: draft.repeat_count,
                  })
                );
                localStorage.removeItem("lastAttendQuestion");
              }
              this.router.navigateByUrl("/survey");
            }
          });
        } else {
          this.error = "Email or password is incorrect";
          this.loading = false;
        }
      });
  }

  register(form) {
    if (this.form.valid) {
      this.authenticationService.register(form).subscribe((result) => {
        if (result === true) {
          //this.form.reset();
          //this.toastr.success('Registration has been completed successfully', 'Success');
          this.model.email = form["email"];
          this.model.password = form["password"];
          this.userLogin();
        } else {
          this.toastr.error("Everything is broken", "Error", {
            timeOut: 3000,
          });
        }
      });
    } else {
      Object.keys(this.form.controls).forEach((field) => {
        const control = this.form.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  forgotPassword(form) {
    if (this.forgotForm.valid) {
      this.authenticationService.forgotPassword(form).subscribe((result) => {
        if (result > 0) {
          this.forgotForm.reset();
          this.toastr.success(
            "Reset password link has been sent to your email address",
            "Success"
          );
        } else {
          this.toastr.error("Everything is broken", "Error", {
            timeOut: 3000,
          });
        }
      });
    } else {
      Object.keys(this.forgotForm.controls).forEach((field) => {
        const control = this.forgotForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  isEmailUnique(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService
          .isEmailRegisterd(control.value)
          .subscribe((data) => {
            if (data) {
              resolve({ isEmailUnique: true });
            } else {
              resolve(null);
            }
          });
      }, 1000);
    });
    return q;
  }

  isUsernameUnique(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService
          .isUsernameRegisterd(control.value)
          .subscribe((data) => {
            if (data) {
              resolve({ isUsernameUnique: true });
            } else {
              resolve(null);
            }
          });
      }, 1000);
    });
    return q;
  }

  isRegisteredUser(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService
          .isRegisteredUser(control.value, 2)
          .subscribe((data) => {
            if (data) {
              resolve(null);
            } else {
              resolve({ isRegisteredUser: true });
            }
          });
      }, 1000);
    });
    return q;
  }

  skipLogin() {
    this.authenticationService.skipLogin().subscribe((result) => {
      if (result === true) {
        this.router.navigateByUrl("/survey");
      }
    });
  }

  getCounties() {
    let post = {
      add: "GetCounties",
      call: "GetCounties.Get_Counties",
      data: { state: "oklahoma" },
    };
    this.authenticationService.referWebInfo(post).subscribe((result) => {
      this.counties = result;
    });
  }

  getZipCodes() {
    let countyObj = this.form.controls.county.value;
    if (countyObj) {
      let post = {
        add: "GetZips",
        call: "GetZips.Get_Zips",
        data: { state: "oklahoma", county: countyObj.County },
      };
      this.authenticationService.referWebInfo(post).subscribe((result) => {
        this.zipcodes = result;
      });
    } else {
      this.zipcodes = [];
    }
  }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/views/interviewlogin/interviewlogin.component.ts